import React from 'react'
import { isRtl } from 'utils/uiHelpers'
import { DatePicker as DatePickerDS } from '@jisr-hr/design-system'

const DatePicker = (props) => (
  <DatePickerDS
    locale={isRtl ? 'ar' : 'en'}
    displayFormat={isRtl ? 'dd MMMM, yyyy' : 'dd MMM, yyyy'}
    dateFormat="yyyy-MM-dd"
    {...props}
  />
)

export default DatePicker
